import React from "react";
import { usePromiseTracker } from "react-promise-tracker";

export const Spinner = (props) => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress && (
        <div id="spinner-wrapper">
        <div className="spinner"></div>
      </div>
    )
  );
};

